import {
  ArrowLeftOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { message } from 'antd';
import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '@/i18n';
import { getAxios } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import style from './index.module.scss';

export const Aisee = forwardRef((_, ref) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [key, setKey] = useState();
  const AISEE_URL = 'https://h5.aisee.qq.com?appId=fv3pq91ku8&pid=1';
  const htmlRef = useRef<HTMLIFrameElement | null>(null);


  useImperativeHandle(ref, () => ({
    showAisee,
  }));
  const showAisee = async () => {
    let aiSeeKey = key;
    if (!aiSeeKey) {
      try {
        const res = await getAxios().get(`/${API_PREFIX}/api/config/aisee`);
        aiSeeKey = res?.data;
        setKey(aiSeeKey);
      } catch (e) {
        logger.error('getAiseeKey error:', e);
      }
    }

    if (aiSeeKey) {
      setShow(true);
    } else {
      message.error(i18n.t('反馈服务繁忙，请稍后再试！'));
    }
  };

  const onBack = () => {
    if (htmlRef) {
      htmlRef.current?.contentWindow?.postMessage('back', '*');
    } else {
      message.error(i18n.t('回到上一页失败，请通过点击页面上具体按钮跳转到指定页面'));
    }
  };

  if (!show) {
    return null;
  }

  return <div id="h5DemoBox" className={style.demoBox}>
    <div className={style.demoHeader}>
      <div className={style.demoBack} onClick={onBack}>
        <ArrowLeftOutlined />
      </div>
      <div>{t('Bugly 问题反馈')}</div>
      <div className={style.demoClose} onClick={() => setShow(false)}>
        <CloseOutlined />
      </div>
    </div>
    <iframe
      ref={htmlRef}
      className={style.demoFrame}
      src={`${AISEE_URL}&data=${key}`}
      frameBorder="0"
    />
  </div>;
});
